
import RegistrationComponent from '@/components/modules/RegistrationComponent';
export default {
    props: ['error'],
    components: {
        RegistrationComponent
    }
}
